import { FC } from "react";
import { useOverlays } from "contexts/OverlayContext";
import { MultiEntityUpgradeModal } from "./MultiEntityUpgradeModal";

export const MultiEntityUpgradeModalContainer: FC = () => {
    const { getOverlayInfo, closeOverlay, overlayIsClosing } = useOverlays();

    if (!getOverlayInfo("multiEntityUpgrade")) {
        return null;
    }

    return (
        <MultiEntityUpgradeModal
            show={!overlayIsClosing}
            onHide={closeOverlay}
        />
    );
};
